import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Resizable } from 'react-resizable'

import { Spinner } from 'components'
import { ImageInput } from 'features'
import { FaRegImage } from 'react-icons/fa'

import { Modifier, EditorState, SelectionState } from 'draft-js'
import classes from './resize.css'
import * as actionCreators from 'store/actions';
import { resetBlockWithType } from '../Utils'

const Image = styled.img `
    object-fit: 'contain';
    width: ${props => `${props.size*100}%`};
    /* margin: 0.5rem 0; */
    border-radius: 5px;
`

const Container = styled.div`
    /* border: 1px solid grey; */
    border-radius: 5px;
    width: 100%;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`

const Placeholder = styled.div`
    color: var(--primary-accent-color);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: var(--primary-color);
    padding: 1rem;
    border-radius: 5px;
    width: 100%;
    :hover {
        filter: brightness(var(--brightness));
    };
`

class ImageBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // src: this.props.block.getData().get('src') || 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Image_created_with_a_mobile_phone.png/1200px-Image_created_with_a_mobile_phone.png',
            src: this.props.block.getData().get('src'),
            width: 200,
            widthRef: 200,
            heightRef: 200,
            height: 200,
            size: this.props.size || 1
        }
        this.ref = React.createRef();
        this.focusButton = this.focusButton.bind(this);
    }


    static getDerivedStateFromProps(nextProps, prevState){
        let updatedState = {...prevState}
        const data = nextProps.block.getData().toJS()
        updatedState['src'] = data['src']
        console.log(data)
        return updatedState
    }

    focusButton = () => {
        this.ref.current.focus();
    }

    onRemove = () => {
        if(!this.state.src){
            const newState = resetBlockWithType(this.props.blockProps.editorState)
            this.props.blockProps.setEditorState(newState)
        }
        this.props.blockProps.onPopper()
    }

    onSelect = () => {
        const imageInput = <ImageInput 
                                onSubmit={this.onSubmit}
                                onClose={this.onRemove}
                                closeHandler={() => this.props.blockProps.onPopper()}
                                />
        const boundingRect = this.ref.current.getBoundingClientRect()
        boundingRect && this.props.blockProps.onPopper(imageInput, this.ref.current.getBoundingClientRect())
    }

    onSubmit = (link) => {
        // Update block
        this.setState({
            src: link
        })
        // Update editorState
        const newContentState = Modifier.setBlockData(this.props.contentState, SelectionState.createEmpty(this.props.block.getKey()), {src: link})
        const newState = EditorState.push(this.props.blockProps.editorState, newContentState, 'img-src')
        this.props.blockProps.setEditorState(newState)
    }

    onResize = (event, {element, size, handle}) => {
        const newSize = size.height / this.state.heightRef
        this.setState({
            width: size.width,
            height: size.height,
            size: newSize > 1 ? 1 : newSize
        })
    };

    onResizeStart = (event, {element, size, handle}) => {
        const boundingRect = this.ref.current.getBoundingClientRect()
        this.setState({
            width: boundingRect.width,
            height: boundingRect.height,
            widthRef: boundingRect.width,
            heightRef: boundingRect.height,
            size: 1
        })
    }

    onResizeStop = () => {
        // Update editorState
        const newContentState = Modifier.setBlockData(this.props.contentState, this.props.selection, {src: this.state.src, size: this.state.size})
        const newState = EditorState.push(this.props.blockProps.editorState, newContentState, 'img-src')
        this.props.blockProps.setEditorState(newState)
    }

    render() {
        const data = this.props.block.getData().toJS()
        return (
            <Container ref={this.ref}>
                    {data['wait'] & !this.state.src ? <Placeholder><Spinner/></Placeholder>
                    : this.state.src ? 
                    <Resizable width={this.state.width} height={this.state.height} 
                        onResize={this.onResize} onResizeStop={this.onResizeStop} 
                        resizeHandles={['n','s']}>
                        <div><Image onClick={this.onSelect} size={this.state.size} role='presentation' src={this.state.src}/></div>
                    </Resizable>
                    : <Placeholder onClick={this.onSelect}>
                        <FaRegImage style={{fontSize: '1.5rem'}}/>
                        <div style={{marginLeft: '0.5rem', lineHeight: '1.5rem'}}>Add an image</div>
                    </Placeholder>}
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        url: state.content.url,
        error: state.content.error,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        uploadImg: (uid,file) => dispatch(actionCreators.uploadImg(uid,file)),
        uploadReset: () => dispatch(actionCreators.uploadReset())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ImageBlock);